import classNames from "classnames";
import Tooltip from "../Tooltip/Tooltip";
import { Help } from "../Icon/Icon";
import styles from "./Label.module.scss";

function Label({
  hideLabel,
  className,
  label,
  htmlFor,
  tooltip,
  children,
  orientation = "vertical",
  size = "medium",
  reverse,
}: {
  className?: string;
  hideLabel?: boolean;
  label: string;
  tooltip?: React.ReactNode;
  htmlFor?: string;
  children: React.ReactNode;
  orientation?: "horizontal" | "vertical";
  size?: "medium" | "large";
  reverse?: boolean;
}) {
  return (
    <label
      className={classNames(styles.wrapper, styles[orientation], className)}
      htmlFor={htmlFor}
      aria-label={hideLabel ? label : undefined}
    >
      {reverse && children}
      {!hideLabel && (
        <span className={classNames(styles.label, styles[size])}>
          {label}
          {tooltip && (
            <Tooltip content={tooltip} asChild={false}>
              <Help className={styles.icon} />
            </Tooltip>
          )}
        </span>
      )}
      {!reverse && children}
    </label>
  );
}

export default Label;
